export default __webpack_public_path__ + "static/media/excuse-me.c73ef27a.gif";